<template>
    <div id="site-header-container">
        <div class="row justify-content-center align-content-center" id="site-header">
            <div class="col-12" :class="siteCols">
                <div class="row align-content-center align-items-center">
                    <div class="pr-3">
                        <button class="d-lg-none" @click="menu = !menu">
                            <i class="icon icon-menu-gray ml-2"></i>
                        </button>

                        <router-link :to="{name: 'home'}">
                            <i class="icon icon-bazaar-logo-green"></i>
                            <span id="site-name">{{ $t('appName') }}</span>
                        </router-link>
                    </div>

                    <div class="col text-left">
                        <div class="d-none d-lg-flex flex-row-reverse">
                            <ul id="nav">
                                <li v-for="nav in navs" class="nav-item" :class="{active: nav.active === true}" :key="nav.key">
                                    <a :href="nav.link">{{ $t(nav.name) }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center text-center align-items-center d-lg-none" :class="{active: menu}" id="mobile-nav">
            <div v-for="nav in navs" class="col-12 col-sm-6" :class="{active: nav.target === active}" :key="nav.key" @click="goto(nav.target)">{{ $t(nav.name) }}</div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'SiteHeader',
    data: () => ({
        menu: false,
        active: 'search-engine-section',
        navs: [],
    }),
    computed: {
        ...mapState({
            siteCols: state => state.settings.siteCols
        }),
    },
    methods: {
        goto(target) {
            this.active = target;
            this.menu = false;

            const element = document.getElementById(target);
            const top = element.offsetTop;

            window.scrollTo(0, top - 85);
        }
    },
}
</script>

<style scoped>
#site-header-container {
    position: sticky;
    top: 0;
    z-index: 100;
}

#site-header {
    height: 72px;
    line-height: 72px;
    background: #FFF;
    border-bottom: solid 1px rgba(151, 151, 151, 0.45);
    z-index: 1;
}

.icon-bazaar-logo-green {
    width: 51px;
    height: 33px;
}

#site-name {
    color: #212121;
}

#site-name:before {
    vertical-align: middle;
    display: inline-block;
    content: '';
    width: 10px;
    height: 33px;
    border-right: solid 1px rgba(151, 151, 151, 0.45);
    transform: rotate(20deg) translateX(-50%);
    margin: 0 8px;

}

#nav {
    display: flex;
    height: 72px;
}

.nav-item {
    display: inline-flex;
    font-size: 14px;
    color: #212121;
    margin-right: 38px;
    cursor: pointer;
}

.nav-item:first-child {
    margin-right: 0;
}

.nav-item.active, .nav-item:hover {
    color: #0ea960;
}

.nav-item.active {
    font-weight: 500;
    border-bottom: solid 2px #0ea960;
}


/************ responsive ***********************************************************************************************/

@media (max-width: 991.98px) {
    #site-header {
        font-size: 16px;
    }

    #mobile-nav {
        position: fixed;
        top: -100%;
        left: 0;
        margin: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        padding-top: 72px;
        z-index: -1;
    }

    #mobile-nav.active {
        top: 0;
    }

    #mobile-nav .active {
        font-weight: 500;
        color: #0ea960;
    }
}
</style>
